import * as THREE from "three";

export default class Animatable {

    mixer = null

    animationsMap = {};

    /**
     * Binds animations to the entity animation names (anim -> model anim name)
     * @type {{idle: string, run: string, walk: string, jump: string}}
     */
    bindMap = {
        "walk": "walk",
        "idle": "idle",
        "jump": "jump",
        "run": "run",
    };

    currentlyPlaying = null;

    isCurrentlyPlaying() {
        return this.currentlyPlaying !== null
    }

    isPlaying(...animations) {
        for(let i = 0; i < animations.length; i++) {
            if (this.currentlyPlaying === this.getAnimationName(animations[i])) return true
        }
    }

    buildAnimations(model, animations, bindMap = {}) {
        if (!animations)
            return

        // console.log("Animatable.buildAnimations", model);
        this.mixer = new THREE.AnimationMixer(model)
        this.bindMap = {...this.bindMap, ...bindMap};

        animations.forEach((clip) => {
            // console.log(`Animatable::Adding clip: ${clip.name}`, clip)
            if (this.animationsMap[clip.name]) {
                console.warn("Animatable::Animation already exists: ", clip.name)
                return
            }

            this.animationsMap[clip.name] = this.mixer.clipAction(clip)
            this.animationsMap[clip.name].loop = THREE.LoopRepeat
            // this.animationsMap[clip.name].play()
        })

        // console.log("Animatable:", {
        //     animations: animations,
        //     mapper: this.animationsMap,
        //     mixerRoot: this.mixer.getRoot()
        // })
    }

    animate(delta) {
        if (this.mixer) this.mixer.update(delta)
    }

    play(name, loop = true) {
        if (this.currentlyPlaying !== null && this.currentlyPlaying !== this.getAnimationName(name) && this.currentlyPlaying !== name) {
            this.stop(this.currentlyPlaying)
        }

        // this.mixer.stopAllAction()

        let animName = this.getAnimationName(name)
        if (this.animationsMap[animName]) {
            // console.log("Animatable::Playing: ", {
            //     name: name,
            //     anim: this.animationsMap[animName],
            // })
            this.currentlyPlaying = animName
            if (!loop)
                this.animationsMap[animName].reset()

            this.animationsMap[animName].setLoop(loop ? THREE.LoopRepeat : THREE.LoopOnce)
            this.animationsMap[animName].play()
        }
    }

    stopAll() {
        this.mixer.stopAllAction()
    }

    stop(name = null) {
        let animName = this.getAnimationName(name)
        if (this.animationsMap[animName]) {
            this.currentlyPlaying = null
            this.animationsMap[animName].stop()
            return;
        }

        this.mixer.stopAllAction() //Fallback just stop all

        // this.mixer.stopAllAction()
        // console.log("Animatable::Stop: ", name, this.animationsMap)
        // if (name !== null && this.animationsMap[this.bindMap[name]]) {
        //     this.animationsMap[this.bindMap[name]].stop()
        //     return
        // }
        //Dont lookup custom animations in the map (chop custom_ & play)
        // if (name.indexOf("custom_") > -1) {
        //     const n = name.replace("custom_", "")
        //     if (this.animationsMap[n]) this.animationsMap[n].stop()
        //     return
        // }

        // Object.keys(this.animationsMap).forEach(key => {
        //     const a = this.animationsMap[this.bindMap[key]]
        //     if (a) a.stop()
        // })
    }

    getAnimationName(name) {
        if (name === null) return null;

        if (name.indexOf("custom_") > -1) {
            return name.replace("custom_", "")
        } else {
            return this.bindMap[name] || name
        }
    }
}